import Manager from './manager';

const HintManager = new Manager();
HintManager.initPage();

export {
	HintManager as Hint,
};
